module.exports = __webpack_public_path__ + "img/black-virus.464aaaca.png";